import loadGoogleMapsAPI from 'load-google-maps-api'
import ee from '../../ee'
import styles from './styles'

let googleMaps = null
let mapInstances = []

function setMap(el) {
  const latLng = {
    lat: parseFloat(el.dataset.lat),
    lng: parseFloat(el.dataset.lng),
  }

  const map = new googleMaps.Map(el, {
    zoom: 18,
    center: latLng,
    scrollwheel: false,
    disableDefaultUI: true,
    styles,
  })

  new googleMaps.Marker({
    map,
    position: latLng,
    optimized: false,
    label: { text: 'Mather & Co Ltd', className: 'map-marker' },
  })

  return map
}

function setMaps(mapEls) {
  Array.from(mapEls).forEach((el) => {
    const mapInstance = setMap(el)
    mapInstances.push(mapInstance)
  })
}

function refreshMaps() {
  mapInstances.forEach((instance) => {
    setTimeout(() => {
      googleMaps.event.trigger(instance, 'resize')
    }, 1000)
  })
}

function init(container = document) {
  const mapElContainer = container.querySelector('.js-map-container')
  const mapEls = container.querySelectorAll('.js-map')

  if (!mapElContainer || !mapEls.length) {
    return
  }

  const apiKey = mapEls[0].dataset.apikey

  const observer = new IntersectionObserver(
    async ([element], currentObserver) => {
      if (!element.isIntersecting) return

      currentObserver.unobserve(mapElContainer)

      if (!googleMaps) {
        googleMaps = await loadGoogleMapsAPI({ key: apiKey })
      }

      setMaps(mapEls)
    },
    {
      rootMargin: '400px',
      threshold: 0,
    }
  )

  if (mapElContainer) {
    observer.observe(mapElContainer)
  }
}

function destroy() {
  mapInstances = []
}

ee.addListener('initComponents', init)
ee.addListener('destroyComponents', destroy)
ee.addListener('refreshMaps', refreshMaps)
